
export const toFixedString = (num, fixed) => {
  const re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  
  return num.toString().match(re) ? num.toString().match(re)[0] : 0;
}